module.exports = __webpack_public_path__ + "img/photo-projects-cultura-y-ocio.04315131.png";